export default "__VITE_ASSET__8185e01b__"